// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_hr_button {
  margin: 20px 0;
}

.manual_payout_input_fields {
  width: 350px;
  border: 1px solid var(--border);
  border-radius: 5px;
  padding: 0px 10px;
  line-height: 2rem;
  font-size: 16px;
  font-weight: 600;
}

.manual_payout_button_submit {
  padding: 7px 20px;
  border-radius: 4px;
  width: 100px;
  background-color: var(--primary);
  border: solid 1px var(--primary);
  color: white;
}

.manual_payout_button_submit:disabled {
  background-color: #51a5ff;
  border: solid 1px #51a5ff;
}



.manual_payout_form_item {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
}

.manual_payout_custom_fees {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  margin-left: 3rem;
}

.manual_payout_infos {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.manual_payout_iban_selected {
  width: 90%;
  border: 1px solid var(--border);
  padding: 5px 10px;
  border-radius: 4px;
  background-color: var(--bg);
}

.manual_payout_iban_not_selected {
  max-width: 100%;
  width: 90%;
  padding: 5px 10px;
  border-radius: 4px;

}

.manual_payout_iban_not_selected:hover{
  border: 1px solid var(--border);
  background-color: rgb(242, 243, 252, 0.2);
}

.manual_payout_iban_selected p,
.manual_payout_iban_not_selected p {
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/ManualPayout/ManualPayout.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ","sourcesContent":[".modal_hr_button {\n  margin: 20px 0;\n}\n\n.manual_payout_input_fields {\n  width: 350px;\n  border: 1px solid var(--border);\n  border-radius: 5px;\n  padding: 0px 10px;\n  line-height: 2rem;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.manual_payout_button_submit {\n  padding: 7px 20px;\n  border-radius: 4px;\n  width: 100px;\n  background-color: var(--primary);\n  border: solid 1px var(--primary);\n  color: white;\n}\n\n.manual_payout_button_submit:disabled {\n  background-color: #51a5ff;\n  border: solid 1px #51a5ff;\n}\n\n\n\n.manual_payout_form_item {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  align-items: center;\n}\n\n.manual_payout_custom_fees {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  align-items: center;\n  margin-left: 3rem;\n}\n\n.manual_payout_infos {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.manual_payout_iban_selected {\n  width: 90%;\n  border: 1px solid var(--border);\n  padding: 5px 10px;\n  border-radius: 4px;\n  background-color: var(--bg);\n}\n\n.manual_payout_iban_not_selected {\n  max-width: 100%;\n  width: 90%;\n  padding: 5px 10px;\n  border-radius: 4px;\n\n}\n\n.manual_payout_iban_not_selected:hover{\n  border: 1px solid var(--border);\n  background-color: rgb(242, 243, 252, 0.2);\n}\n\n.manual_payout_iban_selected p,\n.manual_payout_iban_not_selected p {\n  margin: 0;\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
